/* eslint-disable no-console */
import { AuthorizationConfig } from 'types';
import { authorize } from 'services/api';
import cacheConfig from './authorizationCache';
import chatttSDK from 'services/chattt';
import { updateUserScope } from 'services/cache';

const authorization: AuthorizationConfig<Oversea.Token.Payload, void> = {
  ...cacheConfig,
  onAuthorize(token, payload) {
    console.log(`"${payload.name}" authorize with token: ${token}`);
    if (chatttSDK?.app?.updateMenuLabel) {
      chatttSDK?.app?.updateMenuLabel(payload.name || payload.account);
    }
    authorize(token);
    if (payload.id) {
      updateUserScope(`${payload.id}`);
    }
  },
  onUnauthorize(code, reason) {
    if (chatttSDK?.app?.updateMenuLabel) {
      chatttSDK?.app?.updateMenuLabel('');
    }
    console.log(`unauthorize (${code}): "${reason}"`);
  },
  getInitialState: () => Promise.resolve(),
};

export default authorization;
